<div class="sidebar-layout" (mouseenter)="onSidebarMouseEnter()" (mouseleave)="onSidebarMouseLeave()">
  <div class="company-logo">
    <div class="logo_style" [innerHTML]="logoSvg"></div>
    <img class="icon_style" src="/assets/images/MI/favicon.ico">
  </div>
  <div class="sidebar-scroll-content scroll-bar-css px-2 no-scrollbar mt-1">
    <p-panelMenu
      class="sidebar-panel-menu"
      [multiple]="isMultipleTabOpen"
      [model]="items"
      [transitionOptions]="menuTransitionOptions">
    </p-panelMenu>
    <div class="version-section-in-sidebar" [title]="buildVersion">
      {{buildVersion}}
    </div>
    <div class="powered-by-section">
      <div class="col-12 wrapper">
        <div>
          <a [href]="poweredByRedirectUrl" target="_blank">
            <img src="/assets/images/temp/powered-by-logo.png">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
